import { render, staticRenderFns } from "./BrandsSections.vue?vue&type=template&id=19b36ce7&scoped=true&"
import script from "./BrandsSections.vue?vue&type=script&lang=js&"
export * from "./BrandsSections.vue?vue&type=script&lang=js&"
import style0 from "./BrandsSections.vue?vue&type=style&index=0&id=19b36ce7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b36ce7",
  null
  
)

export default component.exports